import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './inspirecommila_pagina.module.scss';
import lumina from './src/lumina.jpeg';

const WHATSAPP_URL =
    'https://wa.me/5531995461766?text=' +
    encodeURIComponent('Olá, vim pelo Instagram e quero saber mais sobre a Comunidade LÚMINA.');

const Lumina_inspirecommila: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.page}>
            <div className={styles.sheet}>
                <div className={styles.header}>
                    <Link to="/inspirecommila" className={styles.back} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h1>Comunidade</h1>
                </div>

                <figure className={styles.hero}>
                    <img src={lumina} alt="Mila com microfone" />
                </figure>

                <div className={styles.corpo}>
                    <p className={styles.eyebrow}>LÚMINA</p>
                    <h2 className={styles.titulo}>Caminhe comigo por 1 ano</h2>
                    <p className={styles.lead}>
                        Uma comunidade para mulheres que desejam cuidar das emoções, fortalecer a identidade,
                        amadurecer e viver a fé de forma prática.
                    </p>
                    <div className={styles.texto}>
                        <p>
                            LÚMINA é para quem entendeu que não quer só consumir conteúdo. Quer viver um processo.
                            Ao longo de um ano, trabalhamos o que atravessa a vida real: identidade, autoestima,
                            feridas emocionais, crenças, posicionamento, relacionamentos, rotina, constância, valores,
                            emoções e vida espiritual.
                        </p>
                        <p>
                            Além dos encontros, há ferramentas exclusivas: exercícios, áudioaulas, desafios, PDFs e
                            uma plataforma com tudo organizado, para cada mulher avançar no seu tempo.
                        </p>
                    </div>
                    <p className={styles.citacao}>
                        Consciência, direção e propósito, com princípios bíblicos no caminho.
                    </p>
                    <div className={styles.meta}>
                        <span>R$ 397</span>
                        <span>Acesso por 1 ano</span>
                    </div>
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.cta}
                    >
                        Quero entrar na LÚMINA
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Lumina_inspirecommila;
